export class GcpSourceServices {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gce",
            "baseName": "gce",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gceNativeBackup",
            "baseName": "gceNativeBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcs",
            "baseName": "gcs",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcsInventoryManagement",
            "baseName": "gcsInventoryManagement",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudsql",
            "baseName": "cloudsql",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bigquery",
            "baseName": "bigquery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sapHana",
            "baseName": "sapHana",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gceDiscovery",
            "baseName": "gceDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcsDiscovery",
            "baseName": "gcsDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudsqlDiscovery",
            "baseName": "cloudsqlDiscovery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bigqueryDiscovery",
            "baseName": "bigqueryDiscovery",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSourceServices.attributeTypeMap;
    }
    constructor() {
    }
}
